import { render, staticRenderFns } from "./AdmissionTypeSelection.vue?vue&type=template&id=0495b13f&scoped=true&"
import script from "./AdmissionTypeSelection.vue?vue&type=script&lang=ts&"
export * from "./AdmissionTypeSelection.vue?vue&type=script&lang=ts&"
import style0 from "./AdmissionTypeSelection.vue?vue&type=style&index=0&id=0495b13f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0495b13f",
  null
  
)

export default component.exports